import { render, staticRenderFns } from "./OccupationAreas.vue?vue&type=template&id=81f34eaa&scoped=true"
import script from "./OccupationAreas.vue?vue&type=script&lang=js"
export * from "./OccupationAreas.vue?vue&type=script&lang=js"
import style0 from "./OccupationAreas.vue?vue&type=style&index=0&id=81f34eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f34eaa",
  null
  
)

export default component.exports